<style scoped>
.diglog_h {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  padding: 24px;
  border-bottom: 1px solid #cfd4e8;
  color: #1a1a1a;
}
.diglog_icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.diglog_operation {
  margin: 30px auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.down-device-content {
  width: 100%;
}
.down-device-content .down-device-item {
  width: 100%;
}
.down-device-content .down-device-item .title {
  font-size: 14px;
  color: #0b0a0a;
  background: #ededed;
  padding: 10px;
  border: 1px solid #cfd4e8;
}
.down-device-item-conten{
  height: 400px;
  border: 1px solid #cfd4e8;
  border-top: none;
  padding: 5px;
}
.down-device-content .down-device-item .down-device-item-conten .content{
  margin-top: 10px;
  height: 350px;
  overflow-y: auto;
}
.down-device-content .down-device-item .left{
  border-right: none;

}
.down-device-card{
  border: none!important;
}
.available_frame_tobeselected_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: rgba(26, 26, 26, 0.6);
  padding: 0 12px;
  box-sizing: border-box;
  line-height: 38px;
}
.available_search {
  height: 36px;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #d0d0d0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 16px;
  box-sizing: border-box;
}
.available_search_icon {
  width: 18px;
  height: 18px;
  cursor: pointer;
}
.available_search_input {
  height: 98%;
}
::v-deep .available_search .el-input__inner {
  height: 100%;
  border: none;
}
::v-deep .available_frame_tobeselected_top .el-checkbox__label {
  font-size: 14px;
  color: rgba(26, 26, 26, 0.6);
  font-weight: normal;
}
.available_frame_tobeselected_delte {
  font-size: 14px;
  color: rgba(236, 54, 54, 0.9);
  text-align: right;
  cursor: pointer;
}
.device-option-content{
  white-space: nowrap;
  position: relative;
}
.device-online-dot{
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #1ab137;
  position: absolute;
  left: 0px;
  top:12px;
}
.device-offline-dot{
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ff0000;
  position: absolute;
  left: 0px;
  top:12px;
}
.demo-ruleForm{
  border: 1px solid #d0d0d0;
  padding: 10px;
  border-radius: 3px;
}
.down-device-transfer .online::after {
  margin-left: 10px;
  position: absolute;
  content: "";
  top: 50%;
  transform: translateY(-50%);
  left: 24px;
  width: 8px;
  height: 8px;
  background: #1ab137;
  border-radius: 50%;
}

.down-device-transfer .offline::after {
  margin-left: 10px;
  position: absolute;
  content: "";
  top: 50%;
  transform: translateY(-50%);
  left: 24px;
  width: 8px;
  height: 8px;
  background: #ff0000;
  border-radius: 50%;
}
.down-device-transfer .option_label{
  margin-left: 11px;
}
</style>
<style>
.down-device-transfer .el-transfer-panel{
  width: calc(50% - 100px)!important;
}
</style>

<template>
  <el-dialog
      title=""
      top="30px"
      :visible.sync="availableDialog"
      width="980px"
      :show-close="false"
      :close-on-click-modal="false"
  >
    <div class="diglog_h">
      <div>权限下发</div>
      <img
          src="@/assets/structure/close.png"
          class="diglog_icon"
          @click="availableDialog = false"
      />
    </div>
    <div style="height: calc(100vh - 18rem);overflow-y: auto">
      <el-card :body-style="{ padding: '10px 10px'}" class="down-device-card" shadow="never">
        <div class="down-device-content">
          <el-row>
            <el-col :span="8">
              <div class="down-device-item">
                <div class="title left">部门</div>
                <div class="down-device-item-conten  member left">
                  <!--                <div class="available_frame_tobeselected_top">
                                    <el-input v-model="filterText" placeholder="请搜索部门" >
                                      <i slot="suffix" class="el-input__icon el-icon-search"></i>
                                    </el-input>
                                  </div>-->
                  <div class="available_search">
                    <el-select v-model="selectType" style="width: 125px" placeholder="请选择">
                      <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <el-input
                        v-model="searchFilterText"
                        @keyup.enter.native="searchAvailable"
                        class="available_search_input"
                        :placeholder="selectType == 1 ? '部门名称' : '员工姓名'"
                    >
                    </el-input>
                    <img
                        src="@/assets/structure/search.png"
                        class="available_search_icon"
                        @click="searchAvailable"
                    />
                  </div>
                  <div class="content">
                    <dept-tree-select :filter-text="filterText" @handleNodeClick="handleNodeClick"></dept-tree-select>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="down-device-item">
                <div class="title left">待选择人员</div>
                <div class="down-device-item-conten left">
                  <div class="available_frame_tobeselected_top">
                    <el-checkbox v-model="isSelecAll" style="margin-left: 8px;" @change="selectAllpeople">全选</el-checkbox>
                    <div>已选：{{countCommonValues(waitPeopleList, completePeopleList)}}</div>
                  </div>
                  <el-checkbox-group v-model="completePeopleList">
                    <virtual-list style="height: 22rem; overflow-y: auto;"
                                  :data-key="'id'"
                                  :data-sources="waitPeopleList"
                                  :data-component="memberUnselectedItemComponent"/>
                  </el-checkbox-group>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="down-device-item">
                <div class="title">已选择人员</div>
                <div class="down-device-item-conten">
                  <div class="available_frame_tobeselected_top">
                    <div class="available_frame_tobeselected_delte" @click="deleteAll">全部移除</div>
                    <div>已选：{{completePeopleList.length}}</div>
                  </div>
                  <virtual-list style="height: 22rem; overflow-y: auto;"
                                :data-key="'id'"
                                :data-sources="completePeopleList"
                                :data-component="memberSelectedItemComponent"
                                :extra-props="{deleteSelect}"
                  />
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" style="margin-top: 10px;" class="demo-ruleForm">
          <el-row :gutter="2">
            <el-col :span="16">
              <el-form-item label="" prop="deviceIds" label-width="0">
                <!--              <el-select v-model="ruleForm.deviceIds" multiple  style="width: 100%;" clearable placeholder="请选择门禁设备">
                                <el-option v-for="(item,index) in deviceList"  :label="item.name" :value="item.id">
                                  <div class="device-option-content">
                                    <div class="device-online-dot" v-if="item.status == 1"></div>
                                    <div class="device-offline-dot" v-else></div>
                                    <span style="float: left;margin-left: 20px;">{{ item.name }}</span>
                                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.sn }}</span>
                                  </div>
                                </el-option>
                              </el-select>-->
                <el-transfer
                    filterable
                    :props="{
                    key: 'id',
                    label: 'name'
                  }"
                    :titles="['待选择设备', '已选择设备']"
                    class="down-device-transfer"
                    :filter-method="filterMethod"
                    filter-placeholder="请输入设备名称/SN"
                    v-model="ruleForm.deviceIds"
                    :data="deviceList">
                  <div slot-scope="{ option }" :class="option.disabled ? 'offline' : 'online'">
                    <div class="option_label">
                      <span style="font-size: 14px; font-weight: 400;">{{ option.name }}</span>
                      <span style="color: #b2b2b2;margin-left: 5px;">({{ option.sn }})</span>
                    </div>
                  </div>
                </el-transfer>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="门禁规则" prop="timeRuleId">
                <el-select v-model="ruleForm.timeRuleId"  style="width: 100%;" clearable placeholder="请选择门禁规则">
                  <el-option v-for="(item,index) in timeRuleList" :key="index" :value="item.id" :label="item.name">{{item.name}}</el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="有效期" prop="timeRange">
                <el-date-picker style="width: 100%"
                                v-model="ruleForm.timeRange"
                                type="daterange" clearable
                                @change="handleChangeTimeRange"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                :picker-options="pickerOptions"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
    </div>

    <div class="diglog_operation">
      <el-button @click="availableDialog = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确认</el-button>
    </div>
  </el-dialog>
</template>
<script>
import DeptTreeSelect from "@/views/nexus/permissionAllot/components/DeptTreeSelect.vue";
import VirtualList from 'vue-virtual-scroll-list';
import MemberUnselectedItem from "@/views/nexus/permissionAllot/components/MemberUnselectedItem.vue";
import MemberSelectedItem from "@/views/nexus/permissionAllot/components/MemberSelectedItem.vue";
import { queryUmsUserSimpleList } from "@/api/server/umsUser";
import {TimeRuleApi} from "@/api/nexus/timeRule";
import {DeviceUserTimeRuleApi} from '@/api/nexus/deviceUserRule';
import {NexusDeviceApi} from '@/api/nexus/device';
export default {
  components: {
    DeptTreeSelect, VirtualList
  },
  data() {
    return {
      memberUnselectedItemComponent: MemberUnselectedItem,
      memberSelectedItemComponent: MemberSelectedItem,
      availableDialog: false,
      pickerOptions:{
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; // 设置日期范围为当前时间之后
        }
      },
      options: [
        {
          label: "部门",
          value: 1,
        },
        {
          label: "人员",
          value: 2,
        },
      ],
      selectType: 1, //搜索选择类型
      searchFilterText: '',
      filterText: '',
      queryParam: {},
      selectedAll: false,
      isSelecAll: false, //是否全选
      waitPeopleList: [], //待选人员
      selectIds: [], //已选择人员
      completePeopleList: [], //已选人员
      timeRuleList: [], //规则列表
      deviceList: [], //设备列表
      submitLoading: false,
      ruleForm: {
        timeRuleId: null,
        deviceIds: [],
        timeRange: []
      },
      rules: {
        timeRuleId: [
          { required: true, message: '请选择门禁规则', trigger: 'change' },
        ],
        deviceIds: [
          { required: true, message: '请选择门禁设备', trigger: 'blur' }
        ],
        timeRange: [
          { required: true, message: '请选择有效期', trigger: 'change' }
        ]
      },
    }
  },
  watch: {
    completePeopleList: {
      handler(newValue, oldValue) {
        let that = this;
        if (that.waitPeopleList.length > 0) {
          var filteredArr = that.waitPeopleList.filter(function (item) {
            return !item.isIn;
          });
          // 当 items 数组发生变化时，这个函数会被调用
          let containsAll = filteredArr.every((value) => newValue.includes(value));
          // 你可以在这里执行你想要的操作
          if (containsAll) {
            that.isSelecAll = true;
          } else {
            that.isSelecAll = false;
          }
          var isrepeat = that.hasDuplicates(newValue);
          if (isrepeat) {
            var arr = that.removeDuplicates(newValue);
            that.completePeopleList = arr;
          }
        }
        console.info('completePeopleList_3_',that.completePeopleList);
      },
      deep: true // 深度监听，用于监听数组内部对象的变化
    },
    // 监听待选择列表
    waitPeopleList: {
      handler(newValue, oldValue) {
        let that = this;
        this.completePeopleList.forEach((item) => {
          var index = newValue.findIndex((citem) => item.id == citem.id);
          if (index > -1) {
            that.$set(newValue[index], "checked", true);
          }
        });
      },
      deep: true // 深度监听，用于监听数组内部对象的变化
    },
  },
  methods: {
    searchAvailable(){
      switch (this.selectType){
        case 1:
          this.filterText = this.searchFilterText;
          break;
        case 2:
          queryUmsUserSimpleList({likeString: this.searchFilterText}).then(response => {
            this.waitPeopleList = response.data;
          })
          break;
      }
    },
    handleQueryUmsUserSimpleList(){
      queryUmsUserSimpleList(this.queryParam).then(response => {
        let {code,data} = response;
        if(200 == code){
          this.waitPeopleList = data;
        }
      })
    },
    handleQueryTimeRuleList(){
      TimeRuleApi.querySimpleList().then(response => {
          let {code,data} = response;
          if(200 == code){
            this.timeRuleList = data;
          }
      })
    },
    handleQueryDeviceSimpleList(){
      NexusDeviceApi.querySimpleList().then( response => {
        let {code,data} = response;
        if(200 == code){
          this.deviceList = data?.map(d => {
            d.disabled = (d.status == 0);
            return d;
          });
        }
      })
    },
    show(){
      this.selectedAll = false;
      this.isSelecAll = false; //是否全选
      // this.waitPeopleList = []; //待选人员
      this.selectIds = []; //已选择人员
      this.completePeopleList = []; //已选人员
      this.availableDialog = true;
      this.handleQueryTimeRuleList();
      this.handleQueryDeviceSimpleList();
    },
    hasDuplicates(array) {
      const set = new Set();
      for (let item of array) {
        if (set.has(item.id)) {
          return true; // 如果集合中已经存在该元素，则说明有重复
        }
        set.add(item.id); // 否则将元素添加到集合中
      }
      return false; // 遍历完数组后仍未发现重复项
    },
    removeDuplicates(array) {
      // 使用 Map 来去重，Map 的键是 id，值是对象本身
      const map = new Map();
      for (let item of array) {
        map.set(item.id, item); // 如果 id 已经存在，则会覆盖
      }
      // 将 Map 的值转换回数组
      return Array.from(map.values());
    },
    handleNodeClick(data){
      this.queryParam.deptId = data.id;
      this.handleQueryUmsUserSimpleList();
    },
    // 判断有几个已经选择
    countCommonValues(array1, array2) {
      // 将 array1 的 id 存储在一个集合中
      const set1 = new Set(array1.map((item) => item.id));

      // 计数器
      let commonCount = 0;

      // 遍历 array2 并检查每个 id 是否存在于集合中
      for (let item of array2) {
        if (set1.has(item.id)) {
          commonCount++;
        }
      }

      return commonCount;
    },
    selectAllpeople(value) {
      if (value) {
        var filteredArr = this.waitPeopleList.filter(function (item) {
          return !item.isIn;
        });
        // 合并两个数组
        let combinedArray = this.completePeopleList.concat(filteredArr);

        // 使用 filter 方法去重
        let uniqueArray = combinedArray.filter((value, index, self) => {
          return self.indexOf(value) === index;
        });
        this.completePeopleList = uniqueArray;
      } else {
        let result = this.completePeopleList.filter(
            (item) => !this.waitPeopleList.includes(item)
        );
        this.completePeopleList = result;
      }
    },
    handleChangeTimeRange(value){
      this.ruleForm.periodStartTime = null;
      this.ruleForm.periodEndTime = null;
      if(value && value.length>0){
        this.ruleForm.periodStartTime = value[0];
        this.ruleForm.periodEndTime = value[1];
      }
    },
    // 删除选中的人员
    deleteSelect(index) {
      this.completePeopleList.splice(index, 1);
    },
    // 删除全部选中的人员
    deleteAll() {
      this.completePeopleList = [];
    },
    filterMethod(query, item) {
      console.info(query , '__' , item);
      return item.name.indexOf(query) > -1 || item.sn.indexOf(query) > -1;
    },
    handleSubmit(){
      if(!this.completePeopleList || this.completePeopleList.length == 0){
        this.$message.error('请选择人员...')
        return;
      }
      this.$refs.ruleForm.validate(valid => {
        this.submitLoading = true;
        this.ruleForm.userIds = this.completePeopleList.map(item => item.id);
        console.info('ruleForm__',this.ruleForm);
        DeviceUserTimeRuleApi.insert(this.ruleForm).then(response => {
          let {code,message} = response;
          if(code == 200){
            this.$message.success(message);
            this.availableDialog = false;
            this.$emit('success');
          }else{
            this.$message.error( message);
          }
        }).finally(() => {
          this.submitLoading = false;
        })
      });
    }
  }
}
</script>
